import { useNavigate } from "react-router-dom";
import { componentWithCondition } from "../../newLayout/page/components/hoc/componentWithConditionCheck";

const ChartsAccountAction = () => {
  const navigate = useNavigate();

  const redirectMapAccount = () => navigate("/master/charts_of_account/opr_account_map/");
  const redirectJournalLines = () => navigate("/master/journal_lines");
  return (
    <>
      <li className={`tableButton activeState`}>
        <button onClick={redirectJournalLines}>Journal Lines</button>
      </li>
      <li className={`tableButton activeState`}>
        <button onClick={redirectMapAccount}>Map Account</button>
      </li>
    </>
  );
};

export const ChartsAccountActionWithCheck = componentWithCondition(ChartsAccountAction);
